module.exports = __webpack_public_path__ + "img/selected4-min.2f0f27d3.png";